<template>
    <div v-loading="loading">

        <section class=" bg-white py-4 px-3 rounded-md">
            <div class=" flex items-center justify-between flex-wrap">
                <p><span class=" text-lg font-semibold">Dispatch ID: {{ shippingTimeline?.dispatchReference ||
                    "" }}</span> <span class=" text-gray-400 text-sm rounded">{{
                            formatDate(shippingTimeline?.dispatchedAt) }}</span></p>
                <button v-if="shippingTimeline?.dispatchStatus !== 'delivered'" @click="updateBookingAction"
                    class=" py-2 px-3 bg-primary-yellow rounded mt-2 sm:mt-0">Update
                    Status</button>
            </div>



            <div class="top_list">
                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img class="" src="@/assets/images/icons/number-hash-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Consolidation ID: {{ shippingTimeline?.consolidationReference }}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/list-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Shipment Count: {{ shippingTimeline?.shipmentCount }}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/list-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Item Count: {{ shippingTimeline?.itemCount }}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/weight-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Total weight: {{ shippingTimeline?.totalWeight }}
                    </p>
                </div>
            </div>

            <div class=" bg-primary-green text-white px-3 py-4 my-3 flex gap-4 items-center rounded-xl">
                <div>
                    <span class="standard_wrapper">
                        <img src="@/assets/images/ondemand/fluent-arrow.svg" class="img_standard" />
                    </span>
                </div>
                <div>
                    <b>{{ shippingTimeline?.banner?.title || "Standard Shipping" }}</b>
                    <p>{{ shippingTimeline?.banner?.description || "This order has been shipped to the customer" }}</p>
                </div>
            </div>
        </section>

        <section class="bg-white py-4 rounded-bl-xl rounded-br-xl mt-0 px-3">
            <Timeline :shippingTimeline="shippingTimeline" />
        </section>

        <section class="bg-white py-0 rounded-md mt-4">
            <ShippingInfo :shippingTimeline="shippingTimeline" />
        </section>

        <section>
            <div class="px-0 bg-white rounded-md mt-4  overflow-hidden">
                <p class="text-lg bg-primary-lighterblue py-3 px-3">Order Items</p>
                <table class="custom-table responsive-table border-collapse custom_classs">
                    <thead>
                        <tr class="shadow-md rounded-lg">
                            <th>SHIPPING ID</th>
                            <th>ITEM COUNT</th>
                            <th>SENDER</th>
                            <th>RECEIVER</th>
                            <th>ITEM DESCRIPTION</th>
                            <th>QUANTITY</th>
                            <th>WEIGHT</th>
                            <th>SHIPPING INSTRUCTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pack, index) in shippingTimeline?.shipments" :key="index + 'items'"
                            class="shadow-md rounded-lg">
                            <td>{{ pack?.shippingId || 'N.A' }}</td>
                            <td>{{ pack?.position || '0' }}</td>
                            <td>
                                <span>{{ pack?.sender?.name || 'N.A' }}</span>
                                <span class=" text-sm text-gray-400 block w-full">{{ pack?.sender?.phone || 'N.A'
                                }}</span>
                            </td>
                            <td>
                                <span>{{ pack?.receiver?.name || 'N.A' }}</span>
                                <span class=" text-sm text-gray-400 block w-full">{{ pack?.receiver?.phone || 'N.A'
                                }}</span>
                            </td>
                            <td>{{ getItemDescription(pack?.items || []) }}</td>
                            <td>{{ pack?.itemCount }}</td>
                            <td>{{ getTotalWeight(pack?.items || []) }}</td>
                            <td>{{ getItemInstruction(pack?.items || []) }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <update-status-modal @refetchBooking="refetchBooking" :booking="shippingTimeline"
            :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false"
            @booking-subaction-completed="actionCompleted" :selectedItem="shippingTimeline" />
    </div>
</template>

<script>
import ShippingInfo from "./modules/shipping-info.vue";
import UpdateStatusModal from "./Modals/update-status-modal.vue"
import Timeline from "./modules/timeline.vue";
import moment from "moment"

export default {
    components: {
        ShippingInfo,
        UpdateStatusModal,
        Timeline
    },
    data() {
        return {
            showUpdateStatusModal: false,
            selectedBooking: {},
            shippingTimeline: {},
            loading: true
        }
    },
    mounted() {
        this.getViewTimeline()
    },
    methods: {
        getItemInstruction(items) {
            const instruction = items
                .map(item => item.shippingInstruction)
                .join(", ");
            return instruction;
        },
        getTotalWeight(items) {
            const totalWeight = items.reduce(
                (sum, item) => sum + parseFloat(item.weight) * item.quantity,
                0
            );
            return totalWeight
        },
        getItemDescription(items) {
            const descriptions = items
                .map(item => item.description)
                .join(", ");
            return descriptions;
        },
        actionCompleted() {
            this.getViewTimeline()
        },
        formatDate(date) {
            return moment(date).format('dddd MMMM D, YYYY, h:mmA')
        },
        async getViewTimeline() {
            this.loading = true
            try {
                const response = await this.$_getNewDispatchTimeline(this.$route?.params?.dispatchID);
                this.shippingTimeline = response.data?.data
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loading = false
            }
        },
        updateBookingAction() {
            this.showUpdateStatusModal = true
        },
        refetchBooking() {

        }
    },
}
</script>

<style lang="scss" scoped>
.standard_wrapper {
    @apply w-[50px] h-[50px] rounded-full bg-white inline-flex justify-center items-center;
}

.img_standard {
    @apply w-[30px] h-[30px]
}

.custom_classs {
    margin: 0 !important;
    @apply mx-3 !w-full;
}

.top_list_item_title {
    @apply font-semibold flex-1 mt-1 text-base
}

.top_list_item_img {
    @apply mt-1 -mr-8 w-14
}

.top_list_item {
    @apply w-1/4 px-4 flex flex-wrap justify-evenly border-r-2 border-gray-200 items-center gap-2 mt-3
}

.top_list {
    @apply w-full flex flex-wrap items-center
}

.top_list_item:nth-last-child(1) {
    @apply border-r-0
}
</style>